<template><div><dt-stack gap="650" class="d-mbs-600">
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <h2 class="d-docsite--header-3">Expanded</h2>
      <p class="d-docsite--paragraph"><dt-link to="/foundations/colors/usage/">Color in Product</dt-link></p>
    </div>
    <div class="d-gc2">
      <svg-loader name="color--expanded" class="d-bar-500" />
    </div>
  </div>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <h2 class="d-docsite--header-3">Focused</h2>
      <p class="d-docsite--paragraph"><dt-link to="/foundations/colors/marketing/">Color in Marketing</dt-link></p>
    </div>
    <div class="d-gc2">
      <svg-loader name="color--focused" class="d-bar-500" />
    </div>
  </div>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/color--sample-01.jpg" alt="">
  </figure>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/color--sample-02.jpg" alt="">
  </figure>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/color--sample-03.jpg" alt="">
  </figure>
</dt-stack>
<!--
**Semantic Clarity**
Design Tokens that communicate meaning and purpose

**Accessibility First**
All color combinations meet WCAG 2.1 AA standards for contrast ratios, ensuring readability for all users.

**Flexible Theming**
Support for multiple themes enables personalized experiences while maintaining consistent design patterns. -->
<!--
## What's Inside

### [Color in Product](/foundations/colors/usage/)

Learn how to apply semantic color tokens in your designs and implementations. Understand color roles for text, surfaces, borders, and interactive elements.

### [Color Palette](/foundations/colors/palette/)

Explore Dialtone's complete color palette, including brand purple, grayscales, semantic status colors, and the base tokens that power our semantic system.

### [Chart Colors](/foundations/colors/chart-colors/)

Discover our data visualization color palette designed for clarity and accessibility in charts, graphs, and data-dense interfaces.

### [Themes](/foundations/colors/themes/)

Understand how Dialtone's theming system works and how to implement light and dark modes consistently across your products.

## Getting Started

New to Dialtone colors? Start with [Color in Product](/foundations/colors/usage/) to learn the fundamentals of semantic tokens and how to apply them in your work. If you need to reference specific color values, check out the [Color Palette](/foundations/colors/palette/).

For complete token documentation including CSS variables and design token values, visit our [Tokens documentation](https://dialtone.dialpad.com/tokens/).
-->
</div></template>


